import { Button, FileInput, Label } from "flowbite-react";
import { useEffect, useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import { IoMdCloudDownload } from "react-icons/io";
import { TbExchange } from "react-icons/tb";
import ApiService from '../../../services/ApiServiceClass';

interface ModalFormFileFieldProps {
    register: UseFormRegisterReturn,
    currentAction: string,
    fileToUpload: any,
    isWithQuote: boolean,
    currentDownloadFileID: number,
    currentDownloadFileName: string
}

const ModalFormFileField = ({register, currentAction, fileToUpload, isWithQuote, currentDownloadFileID, currentDownloadFileName}:ModalFormFileFieldProps) => {
    const [showFiles, setShowFiles] = useState(false);
    const [showUploaded, setShowUploaded] = useState(false);
    
    const renderOnAdd = () => {
        return (
            <Label
                htmlFor="fileToUpload"
                className="flex h-38 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:hover:border-gray-500 dark:hover:bg-gray-600"
            >

                {!showFiles && <div className="flex flex-col items-center justify-center pb-6 pt-5">
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                        <span className="font-semibold">Click to upload</span> or drag and drop
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">Quote</p>
                </div>
                }

                {
                    showFiles && <div className="flex flex-wrap gap-2 mx-4 pb-6 pt-5">
                        <div>{fileToUpload[0].name}</div>
                    </div>
                }

                <FileInput id="fileToUpload" className="unhidden absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" {...register} />
            </Label>
        )
    }
    
    const renderOnEdit = () => {
        if (showUploaded) {
            return <div>
                        <div className="grid grid-cols-2 gap-4">
                            <Button onClick={() => handleDownload(currentDownloadFileID, currentDownloadFileName)} 
                                    color="light" 
                                    size="xs">
                                        <IoMdCloudDownload className="mr-2 h-4 w-4" />
                                        Download Quote
                            </Button> 

                            <Button onClick={() => setShowUploaded(false)} 
                                    color="light" 
                                    size="xs">
                                        <TbExchange className="mr-2 h-4 w-4" />
                                        Change Uploaded Quote
                            </Button>                
                        </div>
                        <div className="hidden">
                            {renderOnAdd()} 
                        </div>
                    </div>            
        } else {
            return renderOnAdd();
        }
    }

    const handleDownload = async (id:number, fileName: string) => {
        try {
            const response = await ApiService.downloadFile(id);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch(error) {    
            console.log(error);
        }
    }

    useEffect(() => {
        if (fileToUpload && (fileToUpload.length > 0)) {
            setShowFiles(true);
        }
    }, [fileToUpload]);

    useEffect(() => {
        if (isWithQuote) {
            setShowUploaded(true);
        } else {
            setShowUploaded(false);
        }
    }, [isWithQuote])
    return (
        <div>
            <div className="mb-2 block">
                <Label htmlFor="estimatedCost" value="Upload quote" />
            </div>
            <div className="flex w-full items-center justify-center relative">

                {  (currentAction == "edit") &&  renderOnEdit() }

                {  (currentAction == "add") &&  renderOnAdd() }

            </div>
        </div>
    )
}

export default ModalFormFileField;